import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { 
	setTheme as setThemeReducer,
} from './reducer';

export const themeSlice = createSlice({
  name: 'theme',
  initialState: initialState,
  reducers: {
    setTheme: setThemeReducer,
  },
});

export const { setTheme } = themeSlice.actions;

export const clienteActivoSelector = (state) => state.theme.clienteActivo;

export const listadoTemasSelector = (state) => state.theme.temas;

export default themeSlice.reducer;